// ─── Fase 14 · Bloque 2 — Web Worker client ────────────────────────────────
// Single shared worker; promise-based wrapper around the message protocol.
// Falls back to a synchronous import of monteCarlo if `Worker` is unavailable
// (jsdom in tests, ancient browsers, content-security-policy edge cases).

let worker = null;
let seq = 0;
const pending = new Map();

function getWorker() {
  if (!worker) {
    worker = new Worker(new URL("../mcWorker.js", import.meta.url));
    worker.onmessage = (e) => {
      const p = pending.get(e.data.id);
      if (!p) return;
      pending.delete(e.data.id);
      if (e.data.ok) p.res(e.data.result);
      else            p.rej(new Error(e.data.error));
    };
    worker.onerror = (err) => {
      // Reject all pending promises on a hard worker crash.
      for (const [id, p] of pending) {
        pending.delete(id);
        p.rej(new Error(err.message || "worker error"));
      }
    };
  }
  return worker;
}

export function mcCall(type, ...args) {
  if (typeof Worker === "undefined") {
    // Synchronous fallback — keeps unit tests and SSR-like envs happy.
    return import("../monteCarlo").then((m) => {
      const fnMap = {
        run:     m.runMonteCarlo,
        ci:      m.computeParameterCI,
        stress:  m.runStressTest,
        sizing:  m.runSizingSweep,
        analyze: m.analyzeStrategy,
        business: m.runBusinessSim,
      };
      const fn = fnMap[type];
      if (!fn) throw new Error(`unknown mc fn: ${type}`);
      return fn(...args);
    });
  }
  return new Promise((res, rej) => {
    const id = ++seq;
    pending.set(id, { res, rej });
    getWorker().postMessage({ id, type, args });
  });
}
